module.exports = __webpack_public_path__ + "img/12.31297ba1.jpg";